import moment from 'moment'

export default {
  fromNow (value) {
    return moment(value).fromNow()
  },
  formatDate (value, format) {
    return moment(value).format(format || 'DD-MM-YYYY')
  },
  env (key) {
    if (process.env[key]) {
      return process.env[key]
    }
    return ''
  },
  each (obj, callback) {
    Object.keys(obj).forEach(function (key) {
      callback(key, obj[key])
    })
  },
  static_url (resource, random) {
    return `${process.env.STATIC_BASE_URL}/${resource}` + (random === true ? '?_d=' + (new Date()) : '')
  },
  api_url (resource) {
    return `${process.env.API_BASE_URL}/${resource}`
  },
  pagination (headers) {
    var pagination = {}
    this.each(headers, function (k, v) {
      if (k.indexOf('x-pagination-') === 0) {
        if (v === 'True') {
          v = true
        } else if (v === 'False') {
          v = false
        } else {
          v = parseInt(v)
        }
        pagination[k.split('x-pagination-')[1]] = v
      }
    })
    return pagination
  }
}
